module.exports = __webpack_public_path__ + "static/media/05.b1542db9.wav";